export default __webpack_public_path__ + "static/stephanie-bitmoji-4c58bb928a314538f2ad39f7ac5939bf.png";